import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useCustomToast } from '@/shared/lib';
import {
  containerNotFoundToastTitle,
  findVisibleFolderByCode,
  findVisibleModuleByCode,
  isDirectoryContainerCode,
  loadVisibleDirectoryTree,
} from '@/pages/home';

function resolveItemName(to: RouteLocationNormalized): string {
  const param = to.params.itemName;
  if (!param) return '';
  return Array.isArray(param) ? param.join('/') : param;
}

async function isVisibleContainerPath(itemName: string): Promise<boolean | null> {
  try {
    const tree = await loadVisibleDirectoryTree();
    // A real tree always has the fixed prefix folders, so an empty one means "unknown", not "no folders"
    if (tree.fixedFolders.length === 0) {
      return null;
    }
    return findVisibleFolderByCode(itemName) !== null || findVisibleModuleByCode(itemName) !== null;
  } catch {
    return null;
  }
}

export async function invalidItemNameGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  const itemName = resolveItemName(to);

  if (!itemName) {
    next();
    return;
  }

  const isVisible = await isVisibleContainerPath(itemName);

  if (isVisible === false) {
    if (isDirectoryContainerCode(itemName)) {
      useCustomToast().showErrorToast({ title: containerNotFoundToastTitle(itemName), type: 'error' });
    }
    next({ name: 'Home' });
  } else {
    next();
  }
}
